// extracted by extract-css-chunks-webpack-plugin
module.exports = {"root":"_10_zN","ico":"g2u3B","title":"UbDdt","id":"_12npS"};